/* Rad Dad 2.0 homepage behaviour (Staging v3, 2026-09-08). ~3 KB, no dependencies.
   1. Shop by Benefit tabs   2. Store open-now lines   3. Good News signup via Klaviyo.
   Re-runs on Shopify theme-editor section loads. */
(function () {
  'use strict';

  function benefit(scope) {
    scope.querySelectorAll('[data-rda2-benefit]').forEach(function (root) {
      if (root.dataset.rda2Bound) return;
      root.dataset.rda2Bound = '1';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-rda2-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-rda2-panel]'));
      function select(id, focus) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-rda2-tab') === id;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-rda2-panel') !== id; });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t.getAttribute('data-rda2-tab'), false); });
        t.addEventListener('keydown', function (e) {
          var j = -1;
          if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') j = 0;
          else if (e.key === 'End') j = tabs.length - 1;
          if (j >= 0) { e.preventDefault(); select(tabs[j].getAttribute('data-rda2-tab'), true); }
        });
      });
      root.rda2Select = select;
    });
  }

  function fmtHour(h) {
    h = Math.round(h);
    if (h <= 0 || h >= 24) return '';
    if (h === 12) return '12 PM';
    return h > 12 ? (h - 12) + ' PM' : h + ' AM';
  }

  function stores(scope) {
    scope.querySelectorAll('[data-rda2-store]').forEach(function (s) {
      var out = s.querySelector('[data-rda2-open-line]');
      if (!out) return;
      var open = +s.getAttribute('data-open') || 0;
      var wk = +s.getAttribute('data-wk-close') || 0;
      var sun = +s.getAttribute('data-sun-close') || 0;
      var tz = s.getAttribute('data-tz') || 'America/Chicago';
      var parts;
      try {
        parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: 'numeric', minute: 'numeric', weekday: 'short', hourCycle: 'h23' }).formatToParts(new Date());
      } catch (e) { return; }
      var get = function (type) { var p = parts.filter(function (x) { return x.type === type; })[0]; return p ? p.value : ''; };
      var dow = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
      if (dow < 0) return;
      var hr = (parseInt(get('hour'), 10) % 24) + parseInt(get('minute'), 10) / 60;
      var closeFor = function (d) { return d === 0 ? sun : wk; };
      var names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var c = closeFor(dow), txt, isOpen = false;
      if (!c) {
        txt = 'Closed today';
      } else if (hr < open) {
        txt = 'Opens today at ' + fmtHour(open);
      } else if (hr >= c) {
        txt = '';
        for (var i = 1; i <= 7; i++) {
          var d = (dow + i) % 7;
          if (closeFor(d)) { txt = 'Closed now, opens ' + (i === 1 ? 'tomorrow' : names[d]) + ' at ' + fmtHour(open); break; }
        }
      } else {
        txt = 'Open now until ' + fmtHour(c);
        isOpen = true;
      }
      if (txt) out.textContent = txt;
      s.classList.toggle('rda2-store--closed', !isOpen);
    });
  }

  function newsletter(scope) {
    scope.querySelectorAll('[data-rda2-nl]').forEach(function (wrap) {
      var f = wrap.querySelector('form');
      if (!f || f.dataset.rda2Bound) return;
      f.dataset.rda2Bound = '1';
      var list = wrap.getAttribute('data-list'), company = wrap.getAttribute('data-company');
      var success = wrap.getAttribute('data-success') || 'You are on the list';
      var btn = f.querySelector('[data-rda2-nl-btn]');
      var note = wrap.querySelector('[data-rda2-nl-note]');
      if (!list || !company || !window.fetch || !btn) return; /* Shopify customer form handles it */
      f.addEventListener('submit', function (e) {
        var input = f.querySelector('input[type="email"]');
        var email = input ? input.value.trim() : '';
        if (!email) return;
        e.preventDefault();
        btn.disabled = true;
        if (note) note.textContent = '';
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: { custom_source: 'Homepage: The Good News', profile: { data: { type: 'profile', attributes: { email: email } } } },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          })
        }).then(function (r) {
          if (!r.ok) throw new Error('klaviyo ' + r.status);
          btn.textContent = success;
          if (input) input.disabled = true;
          f.classList.add('rda2-nl__form--done');
        }).catch(function () {
          btn.disabled = false;
          f.submit(); /* fall back to the Shopify customer form (no submit event, no loop) */
        });
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    benefit(scope);
    stores(scope);
    newsletter(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest ? e.target.closest('[data-rda2-tab]') : null;
    var root = tab && tab.closest('[data-rda2-benefit]');
    if (tab && root && root.rda2Select) root.rda2Select(tab.getAttribute('data-rda2-tab'), false);
  });
})();
